import { HttpMethods, makeRequest } from '../helpers/http.helper';
import type {
  Route,
  RouteInput,
  RoutePagination,
  RouteQuery,
  RouteUpdateInput,
} from '../types/route.type';

interface GenericResponse<T> {
  result: T;
}

export async function listRoutes(params: RouteQuery): Promise<RoutePagination> {
  const response = await makeRequest({
    url: '/ops/routes',
    method: HttpMethods.GET,
    params,
  }) as GenericResponse<RoutePagination>;
  return response.result;
}

export async function getRoute(organizationId: string, routeId: string): Promise<Route> {
  const response = await makeRequest({
    url: `/ops/routes/${routeId}`,
    method: HttpMethods.GET,
    params: { organization_id: organizationId },
  }) as GenericResponse<Route>;
  return response.result;
}

export async function createRoute(organizationId: string, input: RouteInput): Promise<Route> {
  const response = await makeRequest({
    url: '/ops/routes',
    method: HttpMethods.POST,
    params: { organization_id: organizationId },
    data: input,
  }) as GenericResponse<Route>;
  return response.result;
}

export async function updateRoute(
  organizationId: string,
  routeId: string,
  input: RouteUpdateInput,
): Promise<Route> {
  const response = await makeRequest({
    url: `/ops/routes/${routeId}`,
    method: HttpMethods.PATCH,
    params: { organization_id: organizationId },
    data: input,
  }) as GenericResponse<Route>;
  return response.result;
}

export async function archiveRoute(organizationId: string, routeId: string): Promise<void> {
  await makeRequest({
    url: `/ops/routes/${routeId}`,
    method: HttpMethods.DELETE,
    params: { organization_id: organizationId },
  });
}

export async function assignTruckToRoute(
  organizationId: string,
  routeId: string,
  truckId: string,
): Promise<Route> {
  const response = await makeRequest({
    url: `/ops/routes/${routeId}/assign-truck`,
    method: HttpMethods.PUT,
    params: { organization_id: organizationId },
    data: { truck_id: truckId },
  }) as GenericResponse<Route>;
  return response.result;
}

export async function unassignTruckFromRoute(organizationId: string, routeId: string): Promise<Route> {
  const response = await makeRequest({
    url: `/ops/routes/${routeId}/unassign-truck`,
    method: HttpMethods.PUT,
    params: { organization_id: organizationId },
  }) as GenericResponse<Route>;
  return response.result;
}
